module.exports = __webpack_public_path__ + "img/logo.a2353325.png";